import { render, staticRenderFns } from "./ContactActionsNotes.vue?vue&type=template&id=e2ede64c&scoped=true&"
import script from "./ContactActionsNotes.vue?vue&type=script&lang=js&"
export * from "./ContactActionsNotes.vue?vue&type=script&lang=js&"
import style0 from "./ContactActionsNotes.vue?vue&type=style&index=0&id=e2ede64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ede64c",
  null
  
)

export default component.exports